import DeleteAutoAssignModal from './DeleteAutoAssignModal'

export default DeleteAutoAssignModal
